import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import FloatingShapes from "@/components/effects/FloatingShapes";

const CTABanner = () => {
  const { ref, isInView } = useScrollAnimation({ threshold: 0.3, triggerOnce: true });

  return (
    <section ref={ref} className="py-16 md:py-24 bg-accent relative overflow-hidden">
      {/* Floating shapes */}
      <FloatingShapes variant="accent" />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-accent via-accent to-accent/90" />

      <div className="container mx-auto px-4 relative z-10">
        <div 
          className={`max-w-4xl mx-auto text-center transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-accent-foreground mb-4">
            Ready to Grow Your Business?
          </h2>
          <p 
            className={`text-lg text-accent-foreground/80 mb-10 max-w-2xl mx-auto transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: '150ms' }}
          >
            Let's talk about your goals. Get a free consultation and discover how we can help you attract more customers and increase revenue.
          </p>

          <div 
            className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: '300ms' }}
          >
            <Button
              size="lg"
              variant="default"
              asChild
              className="min-w-[200px] bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/35 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 group"
            >
              <Link to="/contact">
                Book Free Consultation
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
            <Button
              size="lg"
              variant="glass"
              asChild
              className="min-w-[200px] border-accent-foreground/30 text-accent-foreground backdrop-blur-sm hover:bg-accent-foreground/10 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 group"
            >
              <a href="tel:+19898432600">
                <Phone className="mr-2 h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
                (989) 843-2600
              </a>
            </Button>
          </div>

          <p 
            className={`mt-8 text-sm text-accent-foreground/60 transition-all duration-700 ${isInView ? 'opacity-100' : 'opacity-0'}`}
            style={{ transitionDelay: '450ms' }}
          >
            No pressure. No commitment. Just a conversation about your business.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
